const breakpoints = {
    /**
     * Extra Small Size (375) Mobile
     * iPhone SE y similares
     * max-width: ${breakpoints.ssm}px
    **/
    ssm: 414,
    /**
     * Small Size (480) Mobile
     * Samsung Galazy S y similares
     * max-width: ${breakpoints.sm}px
    **/
    sm: 658,
    /**
     * Medium Size (768) Tablets
     * iPhone 6, 7, 8 y similares
     * max-width: ${breakpoints.md}px
    **/
    md: 768,
    /**
     * Large Size (992) Desktop y Tablets
     * Tablets HP 7 y pantallas antiguas
     * min-width: ${breakpoints.lg}px
    **/
    lg: 1024,
    /**
     * Extra Large Size (1280) Desktop
     * Portatiles y de escritorio
     * min-width: ${breakpoints.xl}px
    **/
    xl: 1024,
    /**
     * Extra Extra Large Size (2500) Desktop
     * Pantallas nuevas y de alta resolución
     * min-width: ${breakpoints.xxl}px
    **/
    xxl: 2500,
  }

  export default breakpoints
